export const packageConstants = {
  GETALL_REQUEST: 'PACKAGE_GETALL_REQUEST',
  GETALL_SUCCESS: 'PACKAGE_GETALL_SUCCESS',
  GETALL_FAILURE: 'PACKAGE_GETALL_FAILURE',

  GET_REQUEST: 'PACKAGE_GET_REQUEST',
  GET_SUCCESS: 'PACKAGE_GET_SUCCESS',
  GET_FAILURE: 'PACKAGE_GET_FAILURE',

  ADD_REQUEST: 'PACKAGE_ADD_REQUEST',
  ADD_SUCCESS: 'PACKAGE_ADD_SUCCESS',
  ADD_FAILURE: 'PACKAGE_ADD_FAILURE',

  UPDATE_REQUEST: 'PACKAGE_UPDATE_REQUEST',
  UPDATE_SUCCESS: 'PACKAGE_UPDATE_SUCCESS',
  UPDATE_FAILURE: 'PACKAGE_UPDATE_FAILURE',
}